import React, { useImperativeHandle, useRef, forwardRef } from 'react'
import WebSignatureCanvas from 'react-signature-canvas'
import CanvasSettings from './CanvasSettings'
import {
  SignatureCanvasProps,
  SignatureCanvasRef,
} from './SignatureCanvas.types'

export const SignatureCanvas = forwardRef<
  SignatureCanvasRef,
  SignatureCanvasProps
>((props, ref) => {
  const sigCanvas = useRef<WebSignatureCanvas>(null)
  useImperativeHandle(
    ref,
    () => {
      return {
        clear: () => {
          sigCanvas.current?.clear()
        },
        getImage: () => {
          const dataUrl = sigCanvas.current?.toDataURL('image/png')
          return dataUrl ? dataUrl.split(',')[1] : undefined
        },
      }
    },
    []
  )
  return (
    <WebSignatureCanvas
      ref={sigCanvas}
      canvasProps={{
        ...CanvasSettings.dimensions,
      }}
    />
  )
})

SignatureCanvas.displayName = 'SignatureCanvas'
